module.exports = __webpack_public_path__ + "img/youtube.2fbe8cc.png";